<template>
    <div class="pdf-viewer">
        <div v-for="(page, index) in pages" :key="index" class="pdf-page" ref="canvasContainer">
            <canvas :ref="'canvas' + index"></canvas>
        </div>
    </div>
</template>

<script>
    import * as pdfjsLib from 'pdfjs-dist/build/pdf'
    import workerSrc from 'pdfjs-dist/build/pdf.worker.js'

    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc
    pdfjsLib.GlobalWorkerOptions.isEvalSupported = false


    export default {
        name: 'PdfViewer',
        data() {
            return {
                pages: []
            };
        },
        mounted() {
            const src = decodeURIComponent(this.$route.query.src || '')
            this.loadPDF(src)
        },
        methods: {
            async loadPDF(url) {
                try {
                    const pdf = await pdfjsLib.getDocument(url).promise
                    const totalPages = pdf.numPages
                    this.pages = new Array(totalPages).fill(null)

                    for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
                        const page = await pdf.getPage(pageNumber);
                        const viewport = page.getViewport({ scale: 1.5 });
                        const canvas = this.$refs[`canvas${pageNumber - 1}`][0];
                        const context = canvas.getContext('2d');
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        await page.render({
                            canvasContext: context,
                            viewport,
                        }).promise;
                    }
                } catch (err) {
                    console.error('PDF 加载失败:', err);
                }
            },
        },
    };
</script>

<style scoped>
    .pdf-viewer {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .pdf-page {
        margin-bottom: 20px;
        box-shadow: 0 0 5px #ccc;
    }

    canvas {
        max-width: 100%;
        height: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/pdf/index.vue